export default __webpack_public_path__ + "static/media/censortwo.475a0af5.png";